import React, { useEffect } from 'react';
import gsap from 'gsap';

export default function ScholarSectionOne () {

    useEffect(() => {
        gsap.from(".nrccs-scholarship", { duration: 1, x: 100, opacity: 0 });
        gsap.to(".nrccs-scholarship", { duration: 1, x: 0, opacity: 1 });
    }, []);


    const ScholarBtn = () => {
        // appley for membership link (google forms) 
        window.open("https://forms.gle/ZPMNt1Y1voGaqEVh8");
    }

    // /http://nrccs.org/wp-content/uploads/2016/11/031.jpg

    return (
        <section
            className="w-screen lg:h-[85vh] h-96 bg-center bg-cover lg:px-24 flex justify-center items-end font-malaya lg:pb-6"
            style={{ backgroundImage: `url(http://nrccs.org/wp-content/uploads/2016/11/031.jpg)` }}
            >
            <div style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }} className="lg:w-[32rem] w-full lg:px-5 lg:pb-10 pb-6 flex flex-col justify-center items-center ">
                <p className="text-center text-slate-50 lg:text-4xl text-xl lg:pt-8 lg:px-0 p-4 nrccs-scholarship uppercase font-semibold">
                    SCholarship
                </p>
                <p className="nrccs-scholarship italic text-center text-xl text-gray-300 pb-6">See if you are qualified</p>
                <button onClick={ScholarBtn} className="text-slate-50 uppercase nrccs-scholarship border py-3.5 w-40 text-sm font-semibold relative group">
                    <div class="absolute inset-0 w-0 bg-slate-50 transition-all duration-300 ease-out group-hover:w-full"></div>
                    <span className="relative group-hover:text-[#1E2332]">
                        Apply
                    </span>
                </button>
            </div>
        </section>
    )
}